
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctDirection as ObiDuctDirectionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-direction.js';
 
 
 

 
 export const ObiDuctDirection = createComponent({
   react: React,
   tagName: 'obi-duct-direction',
   elementClass: ObiDuctDirectionElement,
   events: {
     
   }
  });
 
 